import React, { useEffect } from "react";

const OpenApp = () => {

  useEffect(() => {
    var IOS_STORE = "https://apps.apple.com/app/brightwell-navigator/id1202097542";
    var ANDROID_STORE = "https://play.google.com/store/apps/details?id=com.brightwellpayments.android";
    var FALLBACK_WEB = "https://home.brightwellnavigator.com/crew/download-app";

    function isAndroid() { return /Android/i.test(navigator.userAgent); }
    function isIOS() { return /iPhone|iPad|iPod/i.test(navigator.userAgent); }

    var fallbackUrl = isIOS() ? IOS_STORE : isAndroid() ? ANDROID_STORE : FALLBACK_WEB;

    var didHide = false;
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) didHide = true;
    });

    setTimeout(function () {
      if (!didHide) window.location.replace(fallbackUrl);
    }, 1200);

  }, []);

  return (
    <div>
      <p>Opening the app...</p>
      <p>If app isn't installed, we’ll redirect you to the store.</p>
    </div>
  );
};

export default OpenApp;